/**
 * Checks if a URL is on the same domain as the current page.
 * Relative paths are always considered same-domain.
 * Absolute URLs are treated as cross-domain during SSR to ensure
 * consistent render paths between server and client.
 */
export function isSameDomain(href: string): boolean {
  // Relative paths are same domain
  if (!href.startsWith("http://") && !href.startsWith("https://")) {
    return true;
  }

  // During SSR, treat absolute URLs as cross-domain to avoid hydration mismatches
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const linkUrl = new URL(href);
    return linkUrl.origin === window.location.origin;
  } catch {
    return false;
  }
}
